<template>
  <div class="mb-4">
    <v-card outlined>
      <v-card-title class="py-2 px-4 subtitle-2 grey lighten-4">
        {{ label }}
        <v-chip v-if="refName" x-small class="ml-2" color="purple lighten-4">$ref: {{ refName }}</v-chip>
        <v-spacer />
        <v-btn v-if="!readonly" x-small color="primary" depressed @click="addItem">
          <v-icon x-small left>mdi-plus</v-icon> Add
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text v-if="value && value.length" class="pa-2">
        <v-card
          v-for="(arrayItem, idx) in value"
          :key="idx"
          outlined
          class="mb-2"
        >
          <v-card-title class="py-1 px-3 caption grey lighten-5">
            #{{ idx + 1 }}
            <v-spacer />
            <v-btn v-if="!readonly" icon x-small color="error" @click="removeItem(idx)">
              <v-icon x-small>mdi-delete</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-3">
            <schema-field
              :fields="schema"
              :value="arrayItem"
              :root-value="rootValue"
              :locales="locales"
              :readonly="readonly"
              :entity-id="entityId"
              @input="onItemInput(idx, $event)"
            />
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-text v-else class="text-caption grey--text pa-4">
        No items
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'ArrayObjectField',
  components: {
    SchemaField: () => import('../SchemaField.vue'),
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: '',
    },
    schema: {
      type: [Object, Array],
      required: true,
    },
    refName: {
      type: String,
      default: null,
    },
    rootValue: {
      type: Object,
      required: true,
    },
    locales: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    entityId: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    update(arr) {
      this.$emit('input', arr)
    },
    onItemInput(idx, updatedItem) {
      const arr = [...(this.value || [])]
      arr[idx] = updatedItem
      this.update(arr)
    },
    addItem() {
      this.update([...(this.value || []), this.createDefaultItem()])
    },
    removeItem(idx) {
      const arr = [...(this.value || [])]
      arr.splice(idx, 1)
      this.update(arr)
    },
    createDefaultItem() {
      const newItem = {}
      if (!this.schema) {
        return newItem
      }
      const entries = Array.isArray(this.schema)
        ? this.schema.map(f => [f.key, f])
        : Object.entries(this.schema)
      for (const [key, def] of entries) {
        if (def.type === 'boolean') {
          newItem[key] = false
        } else if (def.type === 'array' || def.type === 'array:int' || def.type === 'array:string') {
          newItem[key] = []
        } else if (def.type === 'object') {
          newItem[key] = {}
        } else {
          newItem[key] = null
        }
      }
      return newItem
    },
  },
}
</script>
